var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9CEB630B-91CA-423C-AB59-8E22AA1A1838") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reactions_main",
    transform: "translate(-20.000000, -57.000000)",
    fill: "#2C2F49",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-(1)",
    transform: "translate(20.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.61660897,18.1675127 L6.88318108,21.0575296 C5.74995773,22.2556716 3.91479013,22.2556716 2.78251822,21.0577691 C1.65001978,19.8603936 1.65001978,17.9199037 2.78229169,16.7227677 L8.25009891,10.9417279 C9.38237081,9.74454396 11.2177196,9.74454396 12.3499915,10.9417279 C12.7274457,11.3408052 13.3394552,11.3408052 13.7169094,10.9417279 C14.0943635,10.5426506 14.0943635,9.89558113 13.7169094,9.49650385 C11.8296838,7.50116538 8.77040664,7.50116538 6.88318108,9.49650385 L1.41541917,15.2774958 C-0.471806389,17.2728342 -0.471806389,20.5073673 1.41541917,22.5027058 C3.30241819,24.4990981 6.3619219,24.4990981 8.25014421,22.5027058 L10.9835721,19.6126888 C11.3610263,19.2136115 11.3610263,18.5665421 10.9835721,18.1674648 C10.6061179,17.7683875 9.99406314,17.7684354 9.61660897,18.1675127 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4431115,1.53472052 C20.3672602,-0.511573505 17.0011158,-0.511573505 14.9252645,1.53472052 L11.3179658,5.09065624 C10.9027856,5.49992487 10.9027856,6.16351875 11.3179658,6.57278738 C11.733146,6.98205601 12.4063251,6.98205601 12.8215053,6.57278738 L16.428804,3.01685166 C17.674245,1.7890949 19.6940812,1.7890949 20.939572,3.01685166 C22.185013,4.2445593 22.185013,6.23460406 20.939572,7.4623117 L14.3245963,13.9831483 C13.0791054,15.2109051 11.0603657,15.2109051 9.81492467,13.9831483 C9.39974444,13.5738797 8.7265654,13.5738797 8.31138517,13.9831483 C7.89620494,14.392417 7.89620494,15.0560109 8.31138517,15.4652795 C10.3872365,17.5115735 13.7522845,17.5115735 15.8281358,15.4652795 L22.4431115,8.94449197 C24.5189628,6.89819794 24.5189628,3.58101454 22.4431115,1.53472052 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.e31bdf0c73ab4d811f25f460bb94973b.svg";
export { ForwardRef as ReactComponent };